// Module
var code = `<template>
  <require from="./instrument-info-widget.scss"></require>
  <global-progress if.bind="loading" size="50" stroke-width="5"></global-progress>
  <div if.bind="!loading && !error" class="instrument-info-widget instrument-info-widget-\${id}" ref="widgetDiv">
    <style>
      .instrument-info-widget-\${id} .instrument-info-widget__data,
      .instrument-info-widget-\${id} .instrument-info-widget__data a {
        font-family: \${font || 'var(--dyn-default-font-family)'};
        font-size: \${fontSize ? fontSize + 'px' : 'var(--dyn-default-font-size)'};
        color: \${color | widgetTemplateColor:isInDashboard} !important;
      }

      .instrument-info-widget-\${id} .instrument-info-widget__header {
        font-family: \${headerFont ? headerFontFont : 'var(--dyn-default-font-family)'};
        font-size: \${headerFontSize ? headerFontSize + 'px' : 'var(--dyn-default-font-size)'};
        color: \${headerColor | widgetTemplateColor:isInDashboard} !important;
      }
    </style>

    <div class="instrument-info-widget__header">
      <div class="instrument-info-widget__header__pl">P/L</div>
      <div class="instrument-info-widget__header__value">Value</div>
    </div>
    <div class="instrument-info-widget__data" repeat.for="d of data">
      <div class="instrument-info-widget__name">\${d.name}</div>
      <div class="instrument-info-widget__pl">\${d.profitLossClosingBalance | numericFormatter:'0,0'}</div>
      <div class="instrument-info-widget__value">\${d.estimatedValueClosingBalance | numericFormatter:'0,0'}</div>
      <div class="instrument-info-widget__pl-percent">
        \${d.estimatedProfitLossPercent |numericFormatter:'0,0.0'}%
      </div>
      <div class="instrument-info-widget__value-percent">
        \${d.estimatedValuePercent |numericFormatter:'0,0.0'}%
      </div>
    </div>
  </div>

  <message if.bind="error" icon="error" colour="mdc-theme--error" class="instrument-info-widget__error">
    \${error.message}</message>
</template>
`;
// Exports
export default code;